module.exports = __webpack_public_path__ + "static/media/01.Akademy Performance Video.70e7784b.mp4";